import React, {useCallback} from "react";
import "./index.scss";
import { useDropzone } from "react-dropzone";
import { uploadFromSting } from "../../Store/firestore";
import { fetchImage } from "../nonUIFuncs";

const Dropzone = (props) => {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        const binaryStr = reader.result;
        console.log(binaryStr);
        uploadFromSting(binaryStr, file.name);
        console.log('file', file);
        // TODO: differenciate between file types image and audio
        props.setUploadedImage({file: fetchImage(file.name), type: file.type, fileName: file.name});
      };
      reader.readAsDataURL(file);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  return (
    <div className="gameData-dropzone-container" style={props.style} {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Drop the files ...</p>
      ) : (
        <p>Drag 'n' drop a file here, or click to select files</p>
      )}
    </div>
  );
};

export default Dropzone;
